import { useState } from "react";
import { User, Mail, Lock, Save, Zap } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import TopNav from "@/components/TopNav";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [cur, setCur] = useState(""); const [np, setNp] = useState(""); const [cp, setCp] = useState("");
  const [b1, setB1] = useState(false); const [b2, setB2] = useState(false);

  const saveProfile = async () => {
    setB1(true);
    try { await api.put("/auth/profile", { name, email }); toast.success("Profile updated"); refresh(); }
    catch (e) { toast.error(apiErr(e)); } finally { setB1(false); }
  };
  const changePw = async () => {
    if (np !== cp) return toast.error("New passwords do not match.");
    setB2(true);
    try { const { data } = await api.post("/auth/change-password", { current_password: cur, new_password: np }); toast.success(data.message); setCur(""); setNp(""); setCp(""); }
    catch (e) { toast.error(apiErr(e)); } finally { setB2(false); }
  };

  return (
    <div className="min-h-screen">
      <TopNav />
      <main className="max-w-2xl mx-auto px-4 sm:px-8 pt-8 pb-24">
        <h1 className="serif text-4xl sm:text-5xl font-extrabold">Profile</h1>
        {user?.credits && (
          <div className="glass rounded-2xl px-5 py-4 mt-6 flex items-center gap-3">
            <Zap size={18} className="text-teal-accent" />
            <div className="text-sm">
              <span className="text-teal-accent font-semibold">{user.credits.total_remaining} AI credits</span>
              <span className="text-muted-foreground"> · {user.credits.free_remaining} free left · resets in {user.credits.next_reset_days} days</span>
            </div>
          </div>
        )}

        <div className="glass-strong rounded-3xl p-7 mt-6">
          <h2 className="serif text-2xl font-bold mb-5">Account</h2>
          <Field icon={User} label="Full name" value={name} onChange={setName} testid="profile-name" />
          <Field icon={Mail} label="Email" value={email} onChange={setEmail} testid="profile-email" />
          <button data-testid="save-profile" onClick={saveProfile} disabled={b1} className="kiq-btn px-6 py-2.5 text-sm mt-2 flex items-center gap-2"><Save size={15} /> {b1 ? "Saving…" : "Save changes"}</button>
        </div>

        <div className="glass-strong rounded-3xl p-7 mt-6">
          <h2 className="serif text-2xl font-bold mb-5">Change password</h2>
          <Field icon={Lock} label="Current password" type="password" value={cur} onChange={setCur} testid="current-password" />
          <Field icon={Lock} label="New password" type="password" value={np} onChange={setNp} testid="new-password" />
          <Field icon={Lock} label="Confirm new password" type="password" value={cp} onChange={setCp} testid="confirm-password" />
          <button data-testid="change-password-btn" onClick={changePw} disabled={b2} className="kiq-btn px-6 py-2.5 text-sm mt-2">{b2 ? "Updating…" : "Update password"}</button>
        </div>
      </main>
    </div>
  );
}

function Field({ icon: Icon, label, type = "text", value, onChange, testid }) {
  return (
    <div className="mb-4">
      <label className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">{label}</label>
      <div className="kiq-input flex items-center gap-3 px-4 py-3">
        <Icon size={17} className="text-teal-accent shrink-0" />
        <input data-testid={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)}
               className="bg-transparent outline-none w-full text-sm" />
      </div>
    </div>
  );
}
